import React from 'react';

export function Header() {
  return (
    <header className="bg-white shadow-sm">
      <div className="max-w-4xl mx-auto px-6">
        <div className="flex items-center gap-4">
          <img
            src="images/banner-topo.jpeg"
            alt="Retrato dos Consumidores de Cerveja 2026"
            className="w-auto"
          />
        </div>
      </div>
    </header>
  );
}
